"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTL007_Send = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const RegistButton_1 = require("../RegistButton");
const DSTL007_Send_Child_1 = require("./DSTL007_Send_Child");
const SendSMSContent_1 = require("./DSTL007_Send_Child/SendSMSContent");
const DSTL007SendStyled = styled_components_1.default.div `
	flex: 1;
	display: flex;
	flex-direction: row;
	gap: ${props => (props.$isMobile ? '0px' : props.$isTablet ? '20px' : '20px')};
	position: relative;
	width: 100%;
	height: 100%;

	.ql-editor {
		word-break: break-all;
	}

	${props => !props.$isMobile &&
    `
		.open_member_list {
			display: flex;
			position: absolute;
			width: 100%;
			background: rgba(16, 16, 16, 0.3);
			z-index: 2;
			border-radius: 10px;
			justify-content: center;
			align-items: center;
			min-height: 100%;
				width: 100%;
				top: 0;
				left: 0;
				border: none;
			

			
		}
		.right_box {
			position: relative;
			flex: 2;
			display: flex;
			flex-direction: row;
			position: relative;
			
			padding: 20px;

			width: 100%;
			max-width: 70%;
			overflow: auto;
			${props.$isTablet && `padding: 0;`}
		}
	`}
	${props => props.$isMobile &&
    `	
			${props.$mobilePage === 'send' && `padding: 20px`};
	
			.tab-item {
				display:flex;
				height: 100%;
			}

			.open_member_list {
				display: flex;
				position: fixed;
				width: 100%;
				height: 100%;
				top: 0;
				left: 0;
				background: rgba(16, 16, 16, 0.3);
				z-index: 2;
				justify-content: center;
    			align-items: center;
			}

			.open-member-list {
				background: #fff;
				width: 90%;
				height: 90%;
				border-radius: 10px;
				padding: 16px 20px;
				
			}
	`}
		${props => props.$isTablet &&
    `
		padding: 20px ;
		.mobile-tab-layout {
			width: unset;
			flex: 1;
			border-style: solid;
			border-color: var(--color-grey-c, #e6e8ed);
			border-width: 1px;
			border-radius: 10px;
			padding:20px
		}

		.open_member_list {
			border-radius: 0px;
		}
	`};
`;
exports.DSTL007_Send = react_1.default.memo(({ mobilePage }) => {
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [selectedId, setSelectedId] = (0, react_1.useState)('');
    const updateSelectedId = (id) => {
        setSelectedId(id);
    };
    const renderMobileView = () => (react_1.default.createElement(DSTL007_Send_Child_1.SendSMSListTable, { selectedId: selectedId, setSelectedId: setSelectedId }));
    const renderDesktopView = () => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SendSMSContent_1.SendSMSContent, { selectedId: selectedId, setSelectedId: setSelectedId }),
        react_1.default.createElement("div", { className: "right_box" },
            react_1.default.createElement(DSTL007_Send_Child_1.SendSMSListTable, { selectedId: selectedId, setSelectedId: updateSelectedId }))));
    const handlerButtonClick = () => {
        APP.eventManager.publish('UPDATE_DETAIL_MENU', {
            menuDetail: 'regist',
            id: undefined,
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DSTL007SendStyled, { "$isMobile": isMobile, "$isTablet": isTablet, "$isDesktop": isDesktop, "$mobilePage": mobilePage, className: "dtsl-007-send wrapper-padding" }, isMobile ? (renderMobileView()) : (renderDesktopView())),
        react_1.default.createElement(RegistButton_1.RegistButton, { handlerButtonClick: handlerButtonClick })));
});
